export default (function () {
  /**
   * Smooth scroll
   *
   */

  const links = document.querySelectorAll('a[href^="#"]');

  for (const link of links) {
    link.addEventListener("click", clickHandler);
  }

  function clickHandler(e) {
    e.preventDefault();
    const scroll_offset = 100;
    const href = this.getAttribute("href");
    const offsetTop = document.querySelector(href).offsetTop - scroll_offset;

    scroll({
      top: offsetTop,
      behavior: "smooth",
    });
  }
})();
